import window from 'window-shim';

export default window.config;
